webpackJsonp([35783957827783],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template: 52px 100px 100px 1fr / auto;\n  height: 100%;\n  background-color: transparent;\n  .index__title {\n    grid-area: 1 / 1 / 2 /-1;\n    z-index: 1;\n  }\n  .index__subtitle {\n    grid-area: 2 / 1 / 3 /-1;\n    z-index: 1;\n  }\n  .index__tagline1 {\n    grid-area: 3 / 1 / 4 /-1;\n    z-index: 1;\n  }\n  .index__tagline2 {\n    grid-area: 4 / 1 / -1 /-1;\n    z-index: 1;\n  }\n'], ['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template: 52px 100px 100px 1fr / auto;\n  height: 100%;\n  background-color: transparent;\n  .index__title {\n    grid-area: 1 / 1 / 2 /-1;\n    z-index: 1;\n  }\n  .index__subtitle {\n    grid-area: 2 / 1 / 3 /-1;\n    z-index: 1;\n  }\n  .index__tagline1 {\n    grid-area: 3 / 1 / 4 /-1;\n    z-index: 1;\n  }\n  .index__tagline2 {\n    grid-area: 4 / 1 / -1 /-1;\n    z-index: 1;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IndexStyled = _styledComponents2.default.section(_templateObject);
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    IndexStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Home - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'Home'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__title' },
	      'My name is Roberto'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__subtitle' },
	      'I am an organized and enthusiastic ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        'Javascript Engineer'
	      ),
	      ' with',
	      _react2.default.createElement(
	        'mark',
	        null,
	        ' 10+ years experience'
	      ),
	      ' and a passion for ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        'development'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__tagline1' },
	      'Currently I am focused on the ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        'frontend, UX, and FP'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__tagline2' },
	      _react2.default.createElement(
	        'mark',
	        null,
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'love' },
	          '\uD83D\uDC9B'
	        ),
	        'js (^es6),',
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'surf' },
	          '\uD83C\uDFC4\u200D'
	        ),
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'ashtanga yoga' },
	          '\uD83E\uDDD8\u200D'
	        ),
	        _react2.default.createElement(
	          'span',
	          { role: 'img', 'aria-label': 'music & playing guitar' },
	          '\uD83C\uDFB8'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { className: 'index__news' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Recently I wrote about:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        data.allMarkdownRemark.edges.map(function (_ref2) {
	          var post = _ref2.node;
	          return _react2.default.createElement(
	            'li',
	            { key: post.id },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { key: post.id, to: post.frontmatter.path },
	              post.frontmatter.title
	            )
	          );
	        })
	      )
	    )
	  );
	};
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	/**
	 * Prop types
	 */
	IndexPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	IndexPage.defaultProps = {
	  data: {
	    allMarkdownRemark: {
	      edges: []
	    }
	  }
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7a186a554b3885cc7cbe.js